import { useState, useEffect } from "react";
import {Col, Form, OverlayTrigger, Tooltip} from "react-bootstrap";

export const MachineParameter = ({name, label, variable, setter, color, desc, signal} ) => {

    const [textColor, setTextColor] = useState("black");

    useEffect( () => {
        if (signal === "reset") {
            setTextColor("black");
        }
    }, [signal])

    let colorClass = "";
    if ( color === "red") {
        colorClass = "text-danger";
    }
    else if (color === "green") {
        colorClass = "text-success";
    }

    const onChange = (e) => {
        setTextColor("red");
        setter(e.target.value);

    }

    return(
        <>
            <Col className={"col-md-2"}>
                <OverlayTrigger
                    placement="top"
                overlay={<Tooltip placement="top">{name} | {desc}</Tooltip>}>
                    <Form.Label className={colorClass}>{label}</Form.Label>
                </OverlayTrigger>
            </Col>
            <Col className={"col-md-1"}>
                <Form.Control
                    name={name} type="text"
                    value={variable}
                    onChange={e => onChange(e)}
                    style={{"color": textColor}}
                />
            </Col>
        </>
    )
};
